import { useState } from "react";
import { useAppName, useBranding } from "@/lib/branding";

/**
 * The organisation's logo (or square icon), as Fully Funded Shifts set it in the head app (theme.py).
 * `fallback` is the bundled image used when nothing has been uploaded or it fails to load.
 * While the branding lookup is in flight the fallback is rendered hidden, so the layout does not
 * jump and the old image never flashes.
 */
export default function BrandLogo({ variant = "logo", fallback, alt, className = "", ...rest }) {
  const { loaded, logoUrl, iconUrl } = useBranding();
  const name = useAppName();
  const [failed, setFailed] = useState(false);
  // The square icon falls back to the wide logo (scaled by the caller's classes) before the bundled icon.
  const uploaded = variant === "icon" ? (iconUrl || logoUrl) : logoUrl;
  const src = loaded && uploaded && !failed ? uploaded : fallback;
  return (
    <img
      src={src}
      alt={alt || name || "Logo"}
      className={`${className}${loaded ? "" : " invisible"}`}
      onError={() => { if (uploaded) setFailed(true); }}
      {...rest}
    />
  );
}
